/**
 * External File Search Agent - Context Engineering Section
 * Section 4: Context Engineering Note
 *
 * Keywords AI Key: EXTERNAL_FILE_SEARCH_CONTEXT_NOTE
 */
import { PromptSectionBase } from '../../../base/systemPrompt/PromptSectionBase';
import { EXTERNAL_FILE_SEARCH_PROMPT_KEYS } from './variables';
export const EXTERNAL_FILE_CONTEXT_PREFIXES = [
    'externalFile',
    'excel',
    'excelRead',
];
class ExternalFileSearchContextNoteSection extends PromptSectionBase {
    constructor() {
        super(...arguments);
        this.keywordsKey = EXTERNAL_FILE_SEARCH_PROMPT_KEYS.contextNote;
        this.fallbackContent = `## Context Engineering

Context items are passed with specific IDs that you must use correctly to link dynamic content.

### Context ID Prefixes

- **page_xxx**: External file content (PDFs, Word docs, uploaded files)
- **excel_xxx**: Excel workbook data and structure
- **excelread_xxx**: Excel read results with cell values and formulas

### Using Context IDs

1. **Reference by ID**: When passing context to sub-agents, use the exact ID
   \`\`\`json
   { "context": ["as_001", "logo_acme"], "purpose": "Research and branding for slide" }
   \`\`\`

2. **Include purpose**: Always explain what the context is for

3. **Group related context**: Put related items in the same context array

4. **Don't fabricate IDs**: Only use IDs returned from tools/searches

### Document ID Patterns

**Page IDs (page_xxx):**
- References to PDF, Word, or PowerPoint pages
- Format: page_abc123
- Contains extracted text content

**Excel IDs (excel_xxx):**
- References to Excel/CSV data
- Format: excel_def45
- Contains cell values and metadata

**Excel Read IDs (excelread_xxx):**
- Results from readExcel tool
- Format: f0|excelread_content|Sheet1!A1:B10
- Contains detailed cell data, formulas, or chart info

### Using Document References
1. Note the IDs from search and read results
2. Include relevant IDs in your submitResults call
3. Other agents can retrieve full content using these IDs`;
    }
}
const contextNoteSection = new ExternalFileSearchContextNoteSection();
/**
 * Get the context note section.
 * Uses Keywords AI if available, otherwise falls back to code.
 */
export function getContextNoteSection(hasResolvedContext = false) {
    let section = contextNoteSection.getContent();
    if (hasResolvedContext) {
        section += `\n\n**Note:** You have access to previously resolved context. Review it before searching to avoid redundant queries.`;
    }
    return section;
}
/**
 * Export constant for backwards compatibility
 */
export const EXTERNAL_FILE_CONTEXT_NOTE = contextNoteSection.getFallbackContent();
